import { useState } from "react";
import axios from "axios";
import { DateTime } from "luxon";
import { useNavigate } from "react-router-dom";
import IconWarningTriangle from "../icons/IconWarningTriangle";
import IconChat from "../icons/IconChat";

function formatDate(value) {
    if (!value) return "";
    const dt = DateTime.fromISO(value, { setZone: true });
    return dt.isValid ? dt.toFormat("dd.MM.yyyy HH:mm") : value;
}

// Shared badge for surfacing BotErrorLog entries wherever a specific question
// or message is displayed (conversation canvas, message timeline, ...): a
// severity-colored warning icon that expands into a detail popup, with a
// shortcut to jump straight to the user's conversation thread.
export default function BotErrorBadge({ errors }) {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [navigatingId, setNavigatingId] = useState(null);

    if (!errors || errors.length === 0) return "";

    const hasError = errors.some((entry) => entry.severity === "ERROR");

    function goToConversation(entry) {
        setNavigatingId(entry.id);
        axios.get("/api/bot-errors/" + entry.id + "/conversation-progress", { withCredentials: true })
            .then((response) => navigate("/messages/byconvprogress/" + response.data.conversationProgressId))
            .catch(() => alert("Не вдалося знайти розмову для цієї помилки"))
            .finally(() => setNavigatingId(null));
    }

    return (
        <div
            className="functional-panelbutton toolbar-popup-anchor"
            onMouseDown={(e) => e.stopPropagation()}
            onClick={() => setIsOpen((prev) => !prev)}
        >
            <IconWarningTriangle fillColor={hasError ? "icon-red" : "icon-yellow"} style={{ height: 20, width: 20 }} />

            {isOpen ? (
                <div className="toolbar-popup toolbar-popup-wide" onClick={(e) => e.stopPropagation()}>
                    <p className="toolbar-popup-title">Помилки бота ({errors.length})</p>
                    <ul className="toolbar-popup-list">
                        {errors.map((entry) => (
                            <li key={entry.id}>
                                <div className="toolbar-popup-error-detail">
                                    <div>
                                        <span className={entry.severity === "ERROR" ? "conversation-info-row-error" : "conversation-info-row-warning"}>
                                            {entry.severity === "ERROR" ? "Помилка" : "Попередження"}
                                        </span>
                                        {" — "}
                                        {entry.operation}
                                    </div>
                                    <div>{entry.errorMessage}</div>
                                    {entry.payload ? (
                                        <div className="toolbar-popup-error-detail-payload">"{entry.payload}"</div>
                                    ) : (
                                        ""
                                    )}
                                    {entry.recipientName ? (
                                        <div>
                                            <span className="toolbar-popup-error-detail-label">Кому:</span> {entry.recipientName}
                                            {entry.chatId ? " (chat " + entry.chatId + ")" : ""}
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <div>
                                        <span className="toolbar-popup-error-detail-label">Коли:</span> {formatDate(entry.dAdd)}
                                    </div>
                                </div>
                                {entry.conversationId && entry.outerUserId ? (
                                    <div
                                        className="toolbar-popup-list-action"
                                        title="Перейти до розмови з користувачем"
                                        onClick={() => navigatingId === null && goToConversation(entry)}
                                    >
                                        <IconChat fillColor={navigatingId === entry.id ? "icon-contrast" : "icon-blue"} style={{ height: 18, width: 18 }} />
                                    </div>
                                ) : (
                                    ""
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            ) : (
                ""
            )}
        </div>
    );
}
